import React, { ReactNode, useState } from 'react';
import { IconCautionBold, IconCheckBold, IconEyeOffBold, IconEyeOnBold, Stack } from '@croquiscom-pvt/zds';
import { vars } from '@croquiscom-pvt/zds/tokens';
import styled from '@emotion/styled';

import { FormItem } from '../FromToolBox/FormItem';
import { TextField, TextFieldProps } from '../FromToolBox/TextField';

export interface FormInputProps extends TextFieldProps {
  label?: ReactNode;
  status?: 'error' | 'success';
  error_message?: string;
  expire_time?: number;
  onExpire?: () => void;
  suffix?: ReactNode;
  button?: ReactNode;
}

export const FormInput: React.FC<React.PropsWithChildren<FormInputProps>> = ({
  label,
  status,
  error_message,
  suffix,
  button,
  type,
  disabled,
  ...props
}) => {
  const has_error = !!error_message;
  const is_valid = status === 'success';
  const [input_type, setInputType] = useState(type);
  const selected_suffix = suffix ? (
    suffix
  ) : has_error ? (
    <IconCautionBold size={24} color={'stateNegativePrimary'} />
  ) : is_valid ? (
    <IconCheckBold size={24} color={'statePositivePrimary'} />
  ) : undefined;

  return (
    <FormItem label={label} error={error_message}>
      <InputContainer>
        <TextField
          disabled={disabled}
          type={input_type}
          state={has_error ? 'error' : undefined}
          {...props}
          suffix={
            <StatusBox gap={8} status={has_error ? 'error' : status} disabled={disabled}>
              {selected_suffix}
              {(input_type === 'password' || type === 'password') && (
                <div
                  onClick={() => {
                    setInputType(input_type === 'password' ? 'text' : 'password');
                  }}
                >
                  {input_type === 'password' && (
                    <IconEyeOffBold size={24} color={disabled ? 'iconDisabled' : 'iconSecondary'} />
                  )}
                  {type === 'password' && input_type === 'text' && (
                    <IconEyeOnBold size={24} color={disabled ? 'iconDisabled' : 'iconSecondary'} />
                  )}
                </div>
              )}
            </StatusBox>
          }
        />
        {button}
      </InputContainer>
    </FormItem>
  );
};

const InputContainer = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;
  gap: 8px;
`;
const StatusBox = styled(Stack)<{ status?: 'error' | 'success'; disabled?: boolean }>`
  color: ${({ status, disabled }) =>
    status === 'error'
      ? vars.color.stateNegativePrimary
      : disabled
        ? vars.color.iconDisabled
        : status === 'success'
          ? vars.color.statePositivePrimary
          : 'inherit'};
`;
